import { FC, useMemo } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import { useIntl } from 'react-intl'

import { PatientMedicineAllergyModel } from '@models/queueProcess'

import { useFixedDraggable } from '@components/FixedDraggable'
import { Tooltip } from '@components/Tooltip'

type Props = {
  triageNotes: string | null
  medicalNotes: string | null
  medicineAllergies: Array<PatientMedicineAllergyModel> | null
}

const QueueNodePatientNotes: FC<Props> = ({ triageNotes, medicalNotes, medicineAllergies }) => {
  const { reference } = useFixedDraggable()
  const intl = useIntl()

  const content = useMemo(() => {
    return (
      <Popover className="w-450px">
        <Popover.Body>
          <Tabs
            variant="pills"
            defaultActiveKey="notes"
          >
            {medicalNotes && (
              <Tab
                eventKey="notes"
                title={intl.formatMessage({ id: 'patient.patient_notes' })}
                className="mt-3"
              >
                <div className="border rounded p-5 mt-3">{medicalNotes}</div>
              </Tab>
            )}

            {triageNotes && (
              <Tab
                eventKey="triage"
                title={intl.formatMessage({ id: 'queue.process.triage_notes' })}
                className="mt-3"
              >
                <div className="border rounded p-5 mt-3">{triageNotes}</div>
              </Tab>
            )}

            {medicineAllergies && medicineAllergies.length > 0 && (
              <Tab
                eventKey="medicine-allergies"
                title={intl.formatMessage({ id: 'queue.process.medicine_allergies' })}
                className="mt-3"
              >
                <div className="border rounded p-5 mt-3 d-flex gap-1">
                  {medicineAllergies.map((allergy) => (
                    <span
                      key={allergy.id}
                      className="badge badge-lg badge-secondary"
                    >
                      {allergy.name}
                    </span>
                  ))}
                </div>
              </Tab>
            )}
          </Tabs>
        </Popover.Body>
      </Popover>
    )
  }, [intl, medicalNotes, medicineAllergies, triageNotes])

  return (
    <OverlayTrigger
      rootClose
      placement="bottom"
      trigger="click"
      overlay={content}
      container={reference}
      popperConfig={{ strategy: 'absolute' }}
    >
      <div>
        <Tooltip
          text={intl.formatMessage({
            id: 'vocabulary.note',
          })}
          placement="top"
        >
          <button
            type="button"
            className="btn btn-sm btn-icon btn-secondary"
          >
            <i className="fa fa-circle-info fs-4" />
          </button>
        </Tooltip>
      </div>
    </OverlayTrigger>
  )
}

export { QueueNodePatientNotes }
